var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"award animatedBox"},[_c('div',{staticClass:"container fluid"},[_c('div',{staticClass:"card p-1"},[_c('fd-table',{attrs:{"componentTitle":'Awards',"routerButton":_vm.routerButton,"tableButton":_vm.actionButton,"indexed":true,"plugin":{
          search: [1, 2],
        },"searchBarTitle":'Search from title...',"getFunction":_vm.getAllAwards}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }